import React, { Component } from 'react';
import PropTypes from 'prop-types';

import "./index.scoped.css";

class BoxLoading extends Component {
    componentDidMount() {
        window.mdui.mutation();
    }

    render() {
        return (
            <div className="loading" style={{ "zIndex": this.props.zIndex || 1 }}>
                <div className="mdui-spinner mdui-spinner-colorful"></div>
            </div>
        );
    }
}




BoxLoading.propTypes = {
    zIndex: PropTypes.string,
};




export default BoxLoading;